import AuthorizationResource from "./authorization.resource";

const authorizationModule = angular
  .module("app.resources.authorization", [])
  .service("Authorization", AuthorizationResource);

export default authorizationModule;



// WEBPACK FOOTER //
// ./src/resources/authorization/authorization.module.js